import { cn } from "@/utils";
import { useInView } from "react-intersection-observer";

export const OurRoadmap = () => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    delay: 500,
    triggerOnce: true,
  });

  return (
    <div className="w-full mx-auto mt-[100px] relative" ref={ref}>
      <div className="text-white w-full text-[29px] leading-normal text-center absolute top-0  flex justify-center">
        <div className={cn("text-white text-[29px] leading-normal text-center fadeInUp", inView && "fadeInUp-active")}>
          <p>Road Map</p>
        </div>
      </div>

      <RoadmapSP className={cn("fadeInUp", inView && "fadeInUp-active")} />
    </div>
  );
};

const RoadmapSP = ({ className }: { className?: string }) => {
  return (
    <div className={cn("roadmap-sp", className)} style={{ animationDelay: "0.2s" }}>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 390 1108.2"
      >
        <title>Our Roadmap</title>

        <defs>
          <clipPath id="clippath">
            <rect className="cls-18" x={114.3} y={100.7} width={27.6} height={27.6} />
          </clipPath>
          <linearGradient
            id="linear-gradient"
            x1={138.3}
            y1={2845.4}
            x2={128.5}
            y2={2844.2}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-2"
            x1={132.9}
            y1={2837.9}
            x2={123.4}
            y2={2836.4}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-3"
            x1={134.7}
            y1={2829.5}
            x2={121.7}
            y2={2826.5}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-4"
            x1={130.7}
            y1={2852.5}
            x2={125.2}
            y2={2849.2}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-5"
            x1={142.4}
            y1={2835.8}
            x2={131.8}
            y2={2834.4}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-6"
            x1={124.6}
            y1={2835.7}
            x2={114}
            y2={2834.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-7"
            x1={139.2}
            y1={2827.6}
            x2={133.8}
            y2={2826.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-8"
            x1={141.9}
            y1={2842.5}
            x2={139.1}
            y2={2842.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-9"
            x1={122.4}
            y1={2827.6}
            x2={117}
            y2={2826.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-10"
            x1={127.8}
            y1={2845.4}
            x2={118}
            y2={2844.2}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-11"
            x1={117}
            y1={2842.3}
            x2={114.3}
            y2={2842.1}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <clipPath id="clippath-1">
            <rect className="cls-18" x={115} y={330.3} width={25.8} height={25.8} />
          </clipPath>
          <linearGradient
            id="linear-gradient-12"
            x1={129.5}
            y1={2620.4}
            x2={123.4}
            y2={2618.9}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-13"
            x1={141.2}
            y1={2606.4}
            x2={133.6}
            y2={2605.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-14"
            x1={126.9}
            y1={2619.1}
            x2={115.9}
            y2={2616.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-15"
            x1={141.3}
            y1={2614.4}
            x2={131.3}
            y2={2612.5}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-16"
            x1={132.9}
            y1={2605.9}
            x2={118}
            y2={2604.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-17"
            x1={130.1}
            y1={2610.2}
            x2={114.6}
            y2={2607.9}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-18"
            x1={136.6}
            y1={2620.1}
            x2={128.5}
            y2={2618.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-19"
            x1={136.4}
            y1={2604.3}
            x2={127.2}
            y2={2603.5}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <clipPath id="clippath-2">
            <rect className="cls-18" x={118} y={564.1} width={21.7} height={21.7} />
          </clipPath>
          <linearGradient
            id="linear-gradient-20"
            x1={141.1}
            y1={2378.9}
            x2={117.6}
            y2={2375.4}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <clipPath id="clippath-3">
            <rect className="cls-18" x={118} y={617} width={21.7} height={21.7} />
          </clipPath>
          <linearGradient
            id="linear-gradient-21"
            x1={124.2}
            y1={2331.5}
            x2={122.6}
            y2={2331.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-22"
            x1={124.2}
            y1={2333.9}
            x2={122.6}
            y2={2333.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-23"
            x1={124.3}
            y1={2327.7}
            x2={122.6}
            y2={2327.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-24"
            x1={130.3}
            y1={2322.2}
            x2={128.1}
            y2={2322.2}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-25"
            x1={134.7}
            y1={2322.2}
            x2={132.5}
            y2={2322.2}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-26"
            x1={139.1}
            y1={2322.2}
            x2={136.9}
            y2={2322.2}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-27"
            x1={138.4}
            y1={2333}
            x2={134}
            y2={2331.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-28"
            x1={133.3}
            y1={2333}
            x2={128.9}
            y2={2331.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-29"
            x1={123}
            y1={2316.2}
            x2={118.6}
            y2={2315.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-30"
            x1={126.1}
            y1={2321}
            x2={120.9}
            y2={2320.8}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <clipPath id="clippath-4">
            <rect className="cls-18" x={119.8} y={797} width={21.7} height={21.7} />
          </clipPath>
          <linearGradient
            id="linear-gradient-31"
            x1={140.8}
            y1={2136.2}
            x2={136.1}
            y2={2134.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-32"
            x1={140.9}
            y1={2138}
            x2={136.1}
            y2={2136.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-33"
            x1={141.3}
            y1={2150.2}
            x2={134.4}
            y2={2149.6}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-34"
            x1={125.5}
            y1={2136.7}
            x2={121.1}
            y2={2136.1}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-35"
            x1={134.1}
            y1={2138}
            x2={126.1}
            y2={2136.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-36"
            x1={136.4}
            y1={2143.2}
            x2={132}
            y2={2142.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-37"
            x1={126.7}
            y1={2142.7}
            x2={123.5}
            y2={2141.9}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-38"
            x1={126}
            y1={2145.1}
            x2={123.5}
            y2={2144.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-39"
            x1={126.6}
            y1={2148.3}
            x2={123.4}
            y2={2147.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-40"
            x1={123.6}
            y1={2142.6}
            x2={120.5}
            y2={2141.9}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-41"
            x1={123.6}
            y1={2148.3}
            x2={120.4}
            y2={2147.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-42"
            x1={123}
            y1={2145.1}
            x2={120.4}
            y2={2144.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-43"
            x1={129.1}
            y1={2142.7}
            x2={126.5}
            y2={2142.4}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-44"
            x1={129.1}
            y1={2148.2}
            x2={126.5}
            y2={2147.9}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-45"
            x1={134.1}
            y1={2149.9}
            x2={120.8}
            y2={2147.7}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-46"
            x1={129.1}
            y1={2145.6}
            x2={126.6}
            y2={2145.3}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <clipPath id="clippath-5">
            <rect className="cls-18" x={118.6} y={899.3} width={21.7} height={21.7} />
          </clipPath>
          <linearGradient
            id="linear-gradient-47"
            x1={140.6}
            y1={2045.8}
            x2={118.7}
            y2={2038.9}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-48"
            x1={126.1}
            y1={2088.4}
            x2={119.2}
            y2={2087.4}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-49"
            x1={138.7}
            y1={2100.9}
            x2={131.7}
            y2={2099.8}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
          <linearGradient
            id="linear-gradient-50"
            x1={138.8}
            y1={2095.7}
            x2={119.5}
            y2={2092.8}
            gradientTransform="translate(0 2952) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ffe500" />
            <stop offset={1} stopColor="#ffe500" />
          </linearGradient>
        </defs>
        <rect className="cls-33" x={-5.4} y={-3.1} width={395.4} height={1135.8} />
        <g className="cls-66">
          <rect className="cls-60" x={-1550.8} y={-1289.4} width={1440} height={605} />
          <rect className="cls-60" x={-1550.8} y={-1369.1} width={1440} height={80} />
          <rect className="cls-60" x={-1550.8} y={-1289.4} width={1440} height={605} />
          <rect className="cls-60" x={-1550.8} y={-1369.1} width={1440} height={80} />
          <rect className="cls-60" x={-1550.8} y={-605} width={1440} height={605} />
          <rect className="cls-60" x={-1550.8} width={1440} height={80} />
          <rect className="cls-60" x={-1550.8} y={-605} width={1440} height={605} />
          <g>
            <rect className="cls-60" x={-1550.8} y={79.7} width={1440} height={605} />
            <rect className="cls-60" x={-1550.8} y={764.1} width={1440} height={605} />
            <rect className="cls-60" x={-1550.8} y={684.4} width={1440} height={80} />
            <rect className="cls-60" x={-1550.8} y={1368.8} width={1440} height={80} />
            <rect className="cls-60" x={-1550.8} y={-684.7} width={1440} height={80} />
            <rect className="cls-60" x={-1550.8} y={-684.7} width={1440} height={80} />
          </g>
        </g>
        <g>
          <path
            className="cls-6"
            d="M52.8,113.3c0,3.6-2.9,6.7-6.7,6.7s-6.7-2.9-6.7-6.7,2.9-6.7,6.7-6.7,6.7,2.9,6.7,6.7Z"
          />
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-3" transform="translate(159.8 122.6)">
                <tspan x={0} y={0}>
                  {"Launch Phase"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(159.8 151.8)">
                <tspan x={0} y={0}>
                  {"2024 Q4"}
                </tspan>
              </text>
            </g>
          </g>
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.5 213.3)">
                <tspan x={0} y={0}>
                  {"1. Launch Daily Fantasy sports app on bot."}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.5 228.5)">
                <tspan x={0} y={0}>
                  {"2. Big Five European Leagues in soccer will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.5 243.6)">
                <tspan x={0} y={0}>
                  {"3. ????????????? (For few users)"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.5 258.8)">
                <tspan x={0} y={0}>
                  {"4. Rank frame will be live"}
                </tspan>
              </text>
            </g>
          </g>
          <path
            className="cls-6"
            d="M47.9,124.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,133.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,142.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,151.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,160.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,169.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,178.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,187.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,196.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,205.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,214.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,223.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,232.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,241v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,250v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,258.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,267.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,276.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,285.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,294.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,303.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,312.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,321.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,330.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,339.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,348.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,357.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,366.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,375.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,384.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,393.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,402.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,411.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,420v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,429v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,437.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,446.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,455.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,464.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,473.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,482.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,491.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,500.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,509.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,518.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,527.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,536.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,545.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,554.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,563.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,572.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,581.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,590v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,599v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,607.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,616.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,625.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,634.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,643.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,652.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,661.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,670.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,679.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,688.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,697.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,706.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,715.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,724.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,733.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,742.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,751.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,760.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,769v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,778v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,786.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,795.9v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,804.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,813.8v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,822.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,831.7v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,840.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,849.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,858.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,867.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,876.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,885.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,894.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,903.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,912.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,921.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7Z"
          />
          <path
            className="cls-6"
            d="M47.9,929.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,938.6v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,947.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,956.5v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,965.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,974.4v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,983.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,992.3v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,1001.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,1010.2v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.7-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,1019.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,1028.1v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,1037v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7ZM47.9,1046v.6c0,.9-.8,1.7-1.7,1.7s-1.7-.8-1.7-1.7v-.6c0-.9.8-1.7,1.7-1.7s1.7.8,1.7,1.7Z"
          />
          <g>
            <path
              className="cls-6"
              d="M53.3,112.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM62.2,112.5h.6c.9,0,1.7.8,1.7,1.7s-.7,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM71.2,112.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM80.1,112.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM89.1,112.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM98,112.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7Z"
            />
            <circle className="cls-42" cx={127.3} cy={114.6} r={23.6} />
            <g className="cls-63">
              <g>
                <path
                  className="cls-11"
                  d="M128.7,103.7v5.5l4.5,3.3,4.5-2.6v-5.1c-1.2-1.2-2.7-2.2-4.2-2.8l-4.8,1.8h0Z"
                />
                <path className="cls-35" d="M128,110.5l-4.4,3.2,1.7,5.1h5.4l1.7-5.1-4.4-3.2h0Z" />
                <path className="cls-39" d="M131.6,127.7l2.6-4.1-3.3-3.5h-5.8l-3.3,3.5,2.6,4.1c2.4.6,5,.6,7.3,0h0Z" />
                <path className="cls-57" d="M124.6,101.1l3.4,1.3,3.4-1.3c-1.1-.3-2.2-.5-3.4-.5s-2.3.2-3.4.5Z" />
                <path
                  className="cls-17"
                  d="M138.3,111.2l-4.5,2.6-1.7,5.4,3.3,3.5,4.9-1.8c.2-.3.3-.6.5-1,.6-1.5,1-3,1.1-4.6l-3.5-4.1h-.1Z"
                />
                <path
                  className="cls-13"
                  d="M124,119.3l-1.7-5.4-4.5-2.6-3.5,4.1c0,1.5.5,2.9,1,4.3.2.4.4.7.6,1.1l5,1.9,3.2-3.5h0Z"
                />
                <path className="cls-37" d="M139,122.9l-3.3,1.3-1.7,2.8c2-.9,3.8-2.3,5.1-4h-.1Z" />
                <path className="cls-46" d="M139.1,106.4v3.5l2.5,2.9c-.2-1.2-.5-2.5-.9-3.6-.5-1-.9-2-1.6-2.8Z" />
                <path className="cls-40" d="M122.2,126.9l-1.7-2.8-3.3-1.3c1.3,1.7,3,3.1,5.1,4h0Z" />
                <path className="cls-56" d="M122.7,112.5l4.5-3.3v-5.5l-4.8-1.8c-1.6.7-3,1.7-4.2,2.8v5.1l4.5,2.6h0Z" />
                <path
                  className="cls-16"
                  d="M114.3,112.9l2.5-2.9v-3.5c-.6.8-1.1,1.7-1.5,2.7-.6,1.2-.8,2.6-1,3.9h0v-.2Z"
                />
              </g>
            </g>
          </g>
          <path
            className="cls-6"
            d="M52.8,343.3c0,3.6-2.9,6.7-6.7,6.7s-6.7-2.9-6.7-6.7,2.9-6.7,6.7-6.7,6.7,2.9,6.7,6.7Z"
          />
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-3" transform="translate(160.5 352.6)">
                <tspan x={0} y={0}>
                  {"Sports and UI/ UX"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(160.5 381.8)">
                <tspan x={0} y={0}>
                  {"expansion"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(160.5 411.1)">
                <tspan x={0} y={0}>
                  {"2025 Q1"}
                </tspan>
              </text>
            </g>
          </g>
          <path
            className="cls-6"
            d="M53.3,341.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM62.2,341.5h.6c.9,0,1.7.8,1.7,1.7s-.7,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM71.2,341.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM80.1,341.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM89.1,341.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM98,341.5h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7Z"
          />
          <circle className="cls-42" cx={128} cy={343.4} r={23.6} />
          <g className="cls-61">
            <g>
              <path
                className="cls-7"
                d="M128.9,332.4c.3-.4.3-1.2.2-1.9h-1.2c-1.6,0-3.2.3-4.6.9,1,.5,2.6,1.3,4.3,2.6.6-.5,1-1,1.3-1.3v-.2h0Z"
              />
              <path
                className="cls-23"
                d="M135.5,339.8c-.6,0-1.2.2-1.6.3,2.1,3.9,3,8.7,3.3,12.2,2.1-2.2,3.5-5.2,3.7-8.5-1.5-1.8-3.4-4.2-5.3-4h0Z"
              />
              <path
                className="cls-34"
                d="M122.4,336.4c1.5-.3,3-1.1,4.1-1.9-2.4-1.6-4.4-2.5-4.8-2.7-2.5,1.4-4.5,3.5-5.7,6.1,1.5-.6,3.2-.9,4.7-1.2.5,0,1-.2,1.5-.3h.2Z"
              />
              <path
                className="cls-15"
                d="M131.3,336.8c.2.2.3.3.4.4.5.5.9,1.1,1.4,1.7.6-.3,1.3-.4,2.1-.5,2.1-.3,3.8,1.4,5.3,3.2-.3-2.7-1.5-5.1-3.2-7-.9,0-2,.3-3,.6-.7.2-1.8.8-3.1,1.6h.1Z"
              />
              <path
                className="cls-27"
                d="M129.6,343.5c.5-1.8,1.1-3.1,2.3-4-.3-.5-.8-1-1.1-1.5-.2-.2-.4-.4-.6-.6-4.7,3.3-11.3,9.2-11.9,14.4,2,2.1,4.7,3.6,7.7,4,1.1-2.2,2.1-6.7,2.8-9.4.3-1.3.5-2.4.8-3.1h0v.2Z"
              />
              <path
                className="cls-8"
                d="M124.2,340.6c1.6-1.5,3.4-2.9,5-4-.5-.4-1-.9-1.6-1.3-1.3,1-3.1,2-5,2.4-.5,0-1.1.2-1.6.3-2.1.3-4,.8-5.6,1.6-.3,1.1-.5,2.3-.5,3.5,0,2.8.9,5.2,2.3,7.4.9-3.7,4.2-7.4,7-10h0Z"
              />
              <path
                className="cls-50"
                d="M130.4,335.9c1.5-.9,2.8-1.6,3.7-1.9.8-.3,1.5-.4,2.2-.5-1.6-1.5-3.7-2.5-5.9-2.9,0,.9,0,1.9-.4,2.6-.3.3-.7.8-1.3,1.3.5.4,1.1.9,1.7,1.5h0Z"
              />
              <path
                className="cls-9"
                d="M130.9,343.8c-.2.7-.4,1.8-.8,3-.9,3.7-1.7,7-2.7,9.2h.4c3,0,5.8-1,8-2.8,0-3.7-.9-8.9-3.2-12.7-.9.6-1.3,1.6-1.8,3.2h.1Z"
              />
            </g>
          </g>
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.2 453.2)">
                <tspan x={0} y={0}>
                  {"1. NBA and other sports will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.2 468.4)">
                <tspan x={0} y={0}>
                  {"2. Book maker model will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.2 483.5)">
                <tspan x={0} y={0}>
                  {"3. TMA will be launched"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68.2 498.7)">
                <tspan x={0} y={0}>
                  {"4. ???????? (VIP)"}
                </tspan>
              </text>
            </g>
          </g>
          <path
            className="cls-6"
            d="M52.8,574.5c0,3.6-2.9,6.7-6.7,6.7s-6.7-2.9-6.7-6.7,2.9-6.7,6.7-6.7,6.7,2.9,6.7,6.7Z"
          />
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-3" transform="translate(160.5 583.7)">
                <tspan x={0} y={0}>
                  {"Sports and"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(160.5 612.9)">
                <tspan x={0} y={0}>
                  {"platform expansion"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(160.5 642.2)">
                <tspan x={0} y={0}>
                  {"2025 Q2"}
                </tspan>
              </text>
            </g>
          </g>
          <path
            className="cls-6"
            d="M53.3,572.6h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM62.2,572.6h.6c.9,0,1.7.8,1.7,1.7s-.7,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM71.2,572.6h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM80.1,572.6h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM89.1,572.6h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM98,572.6h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7Z"
          />
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 684.5)">
                <tspan x={0} y={0}>
                  {"1. MLB, Cricket and other sports will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 699.7)">
                <tspan x={0} y={0}>
                  {"2. IOS and Android app will be launched"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 714.9)">
                <tspan x={0} y={0}>
                  {"3. ????????????? (Online or Offline)"}
                </tspan>
              </text>
            </g>
          </g>
          <g>
            <g>
              <circle
                className="cls-42"
                cx={129}
                cy={574.8}
                r={23.6}
                transform="translate(-357.9 243.2) rotate(-43.1)"
              />
              <g className="cls-59">
                <path
                  className="cls-32"
                  d="M135.5,582.7l1.1-1.1.6.6-1.1,1.1-.6-.6ZM134.3,581.6l1.1-1.1.6.6-1.1,1.1-.6-.6ZM133.2,580.5l1.1-1.1.6.6-1.1,1.1-.6-.6ZM132.2,579.4l1.1-1.1.6.6-1.1,1.1-.6-.6ZM137.7,582.7l.6.6-1.1,1.1-.6-.6,1.1-1.1ZM135.7,564.8c.7-.7,1.7-.9,2.5-.5s1.4,1.2,1.4,2.2-.2,1.2-.7,1.7l-5.8,5.8c-.4.3-.7.7-1.1.9l-6,4.1-1.2-1.2,1.3-2,2.1-3.1h.4c.1,0,0,0,0,0h0c2.5,0,4.4-2,4.5-4.5h0v-1l2.3-2.3h.3ZM125,579.9l-1.1-1.1.6-.6,1.1,1.1-.6.6ZM123.9,581l-1.1-1.1.6-.6,1.1,1.1-.6.6ZM122.8,582.1l-1.1-1.1.6-.6,1.1,1.1-.6.6ZM121.7,583.3l-1.1-1.1.6-.6,1.1,1.1-.6.6ZM129.6,571.1c.2,0,.4,0,.5-.2,0-.2,0-.4-.1-.5,0,0,.2-.4.4-.5.1,0,.4,0,.5,0s.1-.4,0-.5c.1,0,.3-.2.5-.3,0,0,.3.2.5,0s.3-.3.2-.5c.2,0,.5,0,.7,0-.2,1.7-1.6,3-3.3,3.3,0-.2,0-.5.1-.7h0ZM132.7,567.8c-.4,0-.7,0-1.1.3h0c0,0-.1-.2-.3-.2s-.3,0-.4,0,0,.3,0,.4h0c-.2,0-.5.3-.7.5h0c-.1,0-.4,0-.6,0-.1,0-.1.4,0,.6h0c-.2.2-.4.4-.5.7h0c-.2,0-.4,0-.5,0,0,.2,0,.4.2.5h0c-.1.4-.2.7-.3,1.1-2,0-3.5-1.7-3.6-3.6.4,0,.7,0,1.1-.3h0c0,.2.3.3.5.2.2,0,.3-.3.2-.5h0c.2,0,.5-.3.7-.5h0c0,0,.4,0,.6,0,0,0,0-.4,0-.6h0c.2-.2.4-.4.5-.7h.4c.1,0,.1-.2.1-.4s0-.3-.2-.3h0c.1-.4.2-.7.3-1.1,2,0,3.5,1.7,3.6,3.6h0ZM126.1,565.3c.6-.6,1.4-.9,2.2-1.1,0,.2,0,.5-.1.7-.2,0-.4,0-.5.2,0,0,0,.4,0,.5,0,0-.2.3-.4.5,0,0-.4,0-.5,0s0,.4,0,.5c0,0-.3.2-.5.4,0,0-.3-.2-.5,0s-.3.3-.2.5c-.2,0-.5,0-.7,0,0-.8.5-1.6,1.1-2.2h0ZM125.6,574.8c-.4-.3-.7-.6-1.1-.9l-5.8-5.8c-.4-.4-.7-1-.7-1.7s.2-1.2.7-1.7c.4-.4,1-.7,1.7-.7s1.2.2,1.7.7l2.3,2.3v.7h0c0,2.1,1.3,4,3.3,4.6l-1.7,2.5-.3-.2h0v.2ZM120,582.7l1.1,1.1-.6.6-1.1-1.1.6-.6ZM120.3,585.7c0,0-.4,0-.6,0l-1.7-1.7c0,0,0-.4,0-.6s.4,0,.6,0h0l1.7,1.7s0,0,0,.3,0,.2,0,.3h0ZM131.7,576l1.1,1.6-1.2,1.2-2-1.4,2.1-1.4h0ZM139.6,584.1l-1.7,1.7c-.1,0-.4,0-.6,0-.1,0-.1-.4,0-.6h0l1.7-1.7h0s.1,0,.3,0,.2,0,.3,0,.1.4,0,.6h0Z"
                />
              </g>
            </g>
            <g>
              <circle
                className="cls-42"
                cx={128.9}
                cy={627.9}
                r={23.6}
                transform="translate(-394.2 257.4) rotate(-43.1)"
              />
              <g className="cls-64">
                <g>
                  <path className="cls-12" d="M122.7,619.7h1.5v1.7h-1.5v-1.7Z" />
                  <path
                    className="cls-28"
                    d="M124.2,618.1c0-.2,0-.4-.2-.6s-.4-.2-.5-.2-.4,0-.5.2-.2.4-.2.6v.9h1.5v-.9h-.1Z"
                  />
                  <path className="cls-24" d="M124.2,623.4v-1.4h-1.5v1.4l.8,3.4.8-3.4h-.1Z" />
                  <path
                    className="cls-48"
                    d="M129.5,621.4h-.7c-.1,0-.4,0-.5.2s-.2.3-.2.5v13.9c0,.8.3,1.5.7,2.2h.4c.5-.6.7-1.4.7-2.2v-13.9c0,0,0-.4-.2-.5-.1,0-.3-.2-.5-.2h.3Z"
                  />
                  <path
                    className="cls-25"
                    d="M133.9,621.4h-.7c-.1,0-.4,0-.5.2s-.2.3-.2.5v13.9c0,.8.3,1.5.7,2.2h.5c.5-.6.7-1.4.7-2.2v-13.9c0,0,0-.4-.2-.5-.1,0-.3-.2-.5-.2h.2Z"
                  />
                  <path
                    className="cls-49"
                    d="M138.3,621.4h-.7c-.1,0-.4,0-.5.2s-.2.3-.2.5v13.9c0,.8.3,1.5.7,2.2h.5c.5-.6.7-1.4.7-2.2v-13.9c0,0,0-.4-.2-.5-.1,0-.3-.2-.5-.2h.2Z"
                  />
                  <path
                    className="cls-41"
                    d="M137.6,618.7h-3c-.4,0-.7.3-.7.7v.7c0,.4.3.7.7.7h3c.4,0,.7-.3.7-.7v-.7c0-.4-.3-.7-.7-.7Z"
                  />
                  <path
                    className="cls-55"
                    d="M132.6,618.7h-3c-.4,0-.7.3-.7.7v.7c0,.4.3.7.7.7h3c.4,0,.7-.3.7-.7v-.7c0-.4-.3-.7-.7-.7Z"
                  />
                  <path
                    className="cls-53"
                    d="M122.4,635.1l-.4.4h-.7v-.3h0v-.3l.4-.4c-.4-.3-.9-.4-1.4-.4s-.9.2-1.3.6-.6.8-.6,1.3,0,.9.4,1.4l.4-.4h.4v.4l-.4.4c.4.3.9.4,1.4.4s.9-.2,1.3-.6c.4-.4.6-.8.6-1.3s0-.9-.4-1.4h0l.2.2ZM121.2,636.3l-.5.5h-.4v-.4l.5-.5h.6v.3h0v.2h-.2Z"
                  />
                  <path
                    className="cls-51"
                    d="M125.2,624l-.4-.2h0l-1,4.6s0,0,0,.2h-.4v-.2c0,0-1.1-4.6-1.1-4.6h0l-.4.2c-.2,0-.4.3-.4.5,0,.2,0,.4,0,.7v8.5c.5,0,1,.3,1.4.6.4.4.7.8.9,1.3s0,1,0,1.5-.4.9-.8,1.3h2.6c0,0,.4,0,.5-.2,0,0,.2-.3.2-.5v-12.4c0-.2,0-.4,0-.7,0-.2-.3-.4-.4-.5h-.4Z"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            className="cls-6"
            d="M52.8,806c0,3.6-2.9,6.7-6.7,6.7s-6.7-2.9-6.7-6.7,2.9-6.7,6.7-6.7,6.7,2.9,6.7,6.7Z"
          />
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-3" transform="translate(160.5 815.2)">
                <tspan x={0} y={0}>
                  {"Sports expansion"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(160.5 844.4)">
                <tspan x={0} y={0}>
                  {"and Big events"}
                </tspan>
              </text>
              <text className="cls-3" transform="translate(160.5 873.7)">
                <tspan x={0} y={0}>
                  {"2025 Q3"}
                </tspan>
              </text>
            </g>
          </g>
          <path
            className="cls-6"
            d="M53.3,804.1h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM62.2,804.1h.6c.9,0,1.7.8,1.7,1.7s-.7,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM71.2,804.1h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM80.1,804.1h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM89.1,804.1h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7ZM98,804.1h.6c.9,0,1.7.8,1.7,1.7s-.8,1.7-1.7,1.7h-.6c-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7Z"
          />
          <g className="cls-2">
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 967.4)">
                <tspan x={0} y={0}>
                  {"1. NFL, Ice Hockey, F1 and other sports"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 982.6)">
                <tspan x={0} y={0} xmlSpace="preserve">
                  {"   will be live"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 997.8)">
                <tspan x={0} y={0}>
                  {"2. VIP ?????????? (In lottery)"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(68 1013)">
                <tspan x={0} y={0}>
                  {"3. Thumba Coin? ("}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-1" transform="translate(152.9 1013)">
                <tspan x={0} y={0}>
                  {"\u2026"}
                </tspan>
              </text>
            </g>
            <g className="cls-2">
              <text className="cls-4" transform="translate(166 1013)">
                <tspan x={0} y={0}>
                  {")"}
                </tspan>
              </text>
            </g>
          </g>
          <g>
            <circle className="cls-42" cx={127.9} cy={909.5} r={23.6} transform="translate(-605.7 356.9) rotate(-45)" />
            <circle
              className="cls-42"
              cx={128.9}
              cy={807.2}
              r={23.6}
              transform="translate(-516.7 305.8) rotate(-43.1)"
            />
            <g className="cls-62">
              <g>
                <path
                  className="cls-19"
                  d="M138.4,816.6c-.9,0-1.7-.2-2.4-.7v.8c0,.7,1.1,1.2,2.4,1.2s2.4-.5,2.4-1.2v-.8c-.7.4-1.5.7-2.4.7Z"
                />
                <path
                  className="cls-31"
                  d="M138.4,815.9c1.3,0,2.4-.5,2.4-1.2s-1.1-1.2-2.4-1.2-2.4.5-2.4,1.2,1.1,1.2,2.4,1.2Z"
                />
                <path className="cls-10" d="M139.4,797l-4.8,8.9h0l1.9,1.2,4.3-8v-2h-1.4Z" />
                <path
                  className="cls-20"
                  d="M123.4,813.2c-.4,0-.9,0-1.2.4-.4.3-.6.7-.7,1.1l-.2.7v1c0,.4.4.9.7,1.2.4.3.8.4,1.3.4h.7l1.4-4.8h-2Z"
                />
                <path
                  className="cls-29"
                  d="M131.8,811.1l-.6,1c-.1.4-.4.7-.7.8-.3.2-.7.3-1.1.3h-1.8l-1.4,4.8h3.2c.4,0,.7,0,1.1-.3.3-.2.6-.5.7-.8l2.5-4.6h0l-1.9-1.2Z"
                />
                <path className="cls-43" d="M134.3,806.5l-2.2,4h0l1.9,1.2,2.2-4h0l-1.9-1.2Z" />
                <path className="cls-58" d="M125.9,809.1v-.4h-2.4v.3l.7,1.7h0c0,0,2.3,0,2.3,0l-.7-1.6h0c0,0,0,0,0,0Z" />
                <path className="cls-5" d="M123.5,806.1h2.4v2h-2.4v-2Z" />
                <path className="cls-38" d="M125.9,804.4h0c0,0,.5-1.7.5-1.7h-2.3l-.6,1.7v.9h2.4v-1h0Z" />
                <path className="cls-22" d="M122.9,809.1v-.4h-2.4v.4l1,1.7h2l-.7-1.6h0c0,0,0,0,0,0h0Z" />
                <path className="cls-21" d="M122.9,804.4h0c0,0,.5-1.7.5-1.7h-2.6v.2c-.2.6-.3,1.2-.3,1.8v.7h2.4v-1h0Z" />
                <path className="cls-14" d="M120.5,806.1h2.4v2h-2.4v-2Z" />
                <path className="cls-26" d="M128.9,807.9l-2.4.8v.4l.7,1.7h0c0,0,1,0,1,0l.7-1.2v-1.8h0Z" />
                <path className="cls-52" d="M126.5,804.5v.9l2.4-.8v-1.8h-1.8l-.6,1.7h0Z" />
                <path
                  className="cls-36"
                  d="M130,798.1c-1.7-.7-3.6-.6-5.3,0-1.7.7-3,2.1-3.7,3.8h8.4v6.5l3.8-5.3v-2.9c-.8-1.2-2-2-3.3-2.5h0v.3ZM129.7,800.7h-.6v-.4h.8v.4h-.2ZM130.3,800.4v-.2h.8v.4h-.8v-.2Z"
                />
                <path className="cls-54" d="M126.5,808l2.4-.8v-2l-2.4.8s0,2,0,2Z" />
              </g>
            </g>
            <g className="cls-65">
              <path
                className="cls-47"
                d="M130.2,908.8h-2.5v-3.1h.4c.7,0,1.4.4,1.8.9h-.9c-.2,0-.4.2-.4.4v.4c0,.2.2.4.4.4h1.4c0,.3,0,.7-.2.9h0ZM122.2,909.2c.4,0,.9,0,1.3.2l-1.3-4c0,0-.2-.3-.4-.3h-2.7c-.2,0-.4.2-.4.4v5.4c0,.2,0,.4.3.4.6-1.3,1.8-2.2,3.3-2.2h-.1ZM139.8,912h-1.4c0,.3.1.6.1.9,0,.5,0,.9-.3,1.4h1.6c.2,0,.4-.2.4-.4v-1.4c0-.2-.2-.4-.4-.4h0ZM132.6,907.4c-.1,0-.3,0-.4,0l-1.7,2.1h-3.8v-4c0-.2-.2-.4-.4-.4-1,0-2,.5-2.8,1.3l1.2,3.8c.7.7,1.1,1.6,1.1,2.6s0,.9-.3,1.4h5.9c-.1-.4-.3-.9-.3-1.4,0-2,1.6-3.6,3.6-3.6s2.5.7,3.1,1.8h1.7c-1.3-1.6-3.8-3.6-7.2-3.6h.3ZM137.6,912.8c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7ZM135.8,912.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9.4.9.9.9.9-.4.9-.9ZM125,912.8c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7ZM123.1,912.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9.4.9.9.9.9-.4.9-.9Z"
              />
            </g>
            <g>
              <circle
                className="cls-42"
                cx={128.9}
                cy={858.1}
                r={23.6}
                transform="translate(-551.4 319.6) rotate(-43.1)"
              />
              <path
                className="cls-44"
                d="M125.8,867.2c-2.7.4-5,0-5.6-.7-.6-.6-1.1-2.8-.7-5.6,1.7,2.5,3.8,4.6,6.3,6.3h0Z"
              />
              <path
                className="cls-45"
                d="M131.8,848.5c2.7-.4,5.1,0,5.6.7.6.6,1.1,2.8.7,5.6-1.7-2.4-3.8-4.5-6.3-6.3h0Z"
              />
              <path
                className="cls-30"
                d="M130,848.9c-2.1.6-4.4,1.7-6.4,3.8-2,2-3.1,4.3-3.8,6.4,2.1,3.3,4.7,5.9,7.7,7.7,2.2-.6,4.4-1.7,6.4-3.8,2-2,3.1-4.3,3.8-6.4-1.9-3-4.5-5.6-7.7-7.7h0ZM130.5,853.2c-.2,0-.5.3-.7.5l.5.5c.2.2.2.5,0,.7s-.5.2-.7,0l-.7-.7c-.4.3-.7.6-1.1.9l.7.7c.2.2.2.5,0,.7s-.5.2-.7,0l-.7-.7c0,0-.2,0-.9.9l.7.7c.2.2.2.5,0,.7s-.5.2-.7,0l-.7-.7c-.3.4-.6.7-.8,1.1l.5.5c.2.2.2.5,0,.7s-.5.2-.7,0l-.4-.4c0,.2-.3.5-.4.7s-.4.4-.7.2-.4-.4-.2-.7c.2-.4.4-.7.6-1l-.6-.6c-.2-.2-.2-.5,0-.7s.5-.2.7,0l.4.4c.3-.4.5-.7.8-1.1l-.3-.3c-.2-.2-.2-.5,0-.7s.5-.2.7,0l.2.2c.7-.9.8-.8.9-.9l-.2-.2c-.2-.2-.2-.5,0-.7s.5-.2.7,0l.2.2c.4-.3.7-.6,1.1-.9l-.3-.3c-.2-.2-.2-.5,0-.7s.5-.2.7,0l.4.4c.3-.2.7-.4.9-.6.2,0,.6,0,.7,0,.1.2,0,.6-.1.7h0l.2.4Z"
              />
            </g>
          </g>
        </g>
        <path
          className="cls-6"
          d="M47.8,1060.7c-.8,1.3-2.7,1.3-3.5,0l-3.5-6c-.8-1.3.2-3,1.7-3h6.9c1.5,0,2.5,1.7,1.7,3l-3.5,6Z"
        />
      </svg>
    </div>
  );
};
